import Hammer from 'hammerjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export default {
	init() {

		function SliderImagesTouch( container ) {

			var containerWidth;
			var carusel = container.querySelector('.sliderImagesTouch__carusel');

			var slides;
			var slidesMax;
			var slidesMarginRight;
			var slidesWidth;

			var slidesPerContainer;

			var counter = 0;
			var transformArray;
			var currentTransform;


			var interval = null;
			var intervalTime = 3000;

			// pswp
			var images = carusel.querySelectorAll('.carusel__image');
			var imagesButton = carusel.querySelectorAll('.carusel__image button');
			

			// -- Support -- //

				function GetTransform() {

					transformArray = [];

					slides.forEach( function( slide , index ) {

						if( index == 0 ) {

							transformArray.push( [0, -slidesWidth] );

						} else {

							transformArray.push( [transformArray[index-1][1] , -(index+1) * slidesWidth] );

						}

					});

				}

				function SetTransform( value ) {

					currentTransform = value;

					carusel.style.transform = 'translateX(' + value + 'px)';

				}

				function NextSlide() {

					counter += 1;

					if( counter >= slidesMax) {

						counter = 0;

					}

					SetTransform(transformArray[counter][0])

				}

				function PrevSlide() {

					counter -= 1;

					if( counter < 0 ) {

						counter = slidesMax;

					}

					SetTransform(transformArray[counter][0])

				}

			// -- END -- //



			// -- Loop -- // 

				function StartLoop() {
					
					if( interval === null ) {

						interval = setInterval(
							function() {
								NextSlide();
							},
							intervalTime
						);

					}

				}

				function EndLoop() {

					clearInterval( interval );
					interval = null;

				}

			// -- END -- // 



			// -- init -- //

				function init() {

					containerWidth = container.offsetWidth;

					slides = container.querySelectorAll('.carusel__image');
					
					slidesMarginRight = parseInt( window.getComputedStyle(slides[0]).marginRight.replace('px','') );
					slidesWidth = slides[0].offsetWidth + slidesMarginRight;	

					slidesPerContainer = parseInt( containerWidth / slidesWidth ) ;
					slidesMax = slides.length - slidesPerContainer;

					GetTransform();
					SetTransform( transformArray[counter][0] );
					StartLoop();

				}	

				window.addEventListener('resize', ev => {

					EndLoop();
					init();

				});

			// -- END -- // 



			init();



			// -- Hammer -- //

				var mc = new Hammer( 
					carusel ,
					{
						inputClass: Hammer.TouchMouseInput
					}

				);

				var panStep;

				function PanStart() {

					EndLoop();
					carusel.classList.add('panMove');

				}

				function PanEnd() {

					carusel.classList.remove('panMove');

					SetTransform(transformArray[counter][0]);
					StartLoop();	
					
				}				

				mc.on('panstart', function(event) {

					panStep = 0;
					PanStart();

				});

				mc.on('panmove',function(){

					PanStart();

				});

				mc.on('panright', function(event) {

					if( panStep - event.distance < 100 ) {
						
						panStep = event.distance;

						SetTransform(event.deltaX + transformArray[counter][0] );

					} else {

						PanEnd();

					}

				});

				mc.on('panleft', function(event) {		

					if( panStep - event.distance > -100 ) {
						
						panStep = event.distance;

						SetTransform(event.deltaX + transformArray[counter][0] );
						
					} else {

						PanEnd();

					}

				});

				
				mc.on('panend', function( event ) {

					transformArray.forEach( function( value, index ) {
						
						if( currentTransform < transformArray[index][0] && currentTransform > transformArray[index][1] ) {

							if( currentTransform < ( transformArray[index][0] - (slidesWidth/2) ) ) {

								counter = index + 1;

							} else {

								counter = index;

							}

						} else if(currentTransform > 0 ){

							counter = 0;

						}

					});

					if( counter < 0  ) {

						counter = 0;

					} else if( counter >= slidesMax ) {

						counter = slidesMax-1;

					}

					PanEnd();

				});

			// -- END -- //



			// -- PhotoSwipe -- //

				var pswp = document.querySelectorAll('.pswp')[0];
				var items; // photoSwipe images
				var options = Array(); // photoSwipe options
				var photoSwipe; // photoSwipe object

				function PhotoSwipeInit(index) {

					items = Array();

					options.index = parseInt(index, 10);
					options.fullscreenEl = false;
					options.shareEl = false;

					var item; 
					var image;
					var image_url;
					var image_dimention;
					var image_width;
					var image_height;

					images.forEach( function( image , index2 ) {

						image_url = image.getAttribute('data-url');
						image_dimention = image.getAttribute('data-size').split('x');
						image_width = image_dimention[0];
						image_height = image_dimention[1];

						item = {

							src: image_url,
		                    w: image_width,
		                    h: image_height

						};

						items.push( item );

					});

					photoSwipe = new PhotoSwipe( pswp, PhotoSwipeUI_Default, items, options);

					photoSwipe.listen('close', function() { 

						StartLoop();

					});

				}

				PhotoSwipeInit();

				imagesButton.forEach( function( button, index ) {

					button.addEventListener('click', function() {

						EndLoop();	
						PhotoSwipeInit( button.closest('.carusel__image').getAttribute('data-index') );
						photoSwipe.init();	

					});

				});

			// -- END -- //


		}


		var container = document.querySelectorAll('.sliderImagesTouch');

		if( container.length > 0 ) {

			container.forEach( function( box , index ){

				SliderImagesTouch(box);

			});

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
